import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from './account.service';

/**
 * Resuelve el `:slug` de la ruta antes de entrar. Si el slug no existe o el
 * usuario no es miembro, manda al redirect de cuenta en vez de mostrar una
 * pantalla vacía: el caso normal es un enlace compartido de otra cuenta.
 */
export const accountGuard: CanActivateFn = async (route) => {
  const accounts = inject(AccountService);
  const router = inject(Router);

  const slug = route.paramMap.get('slug') ?? route.parent?.paramMap.get('slug') ?? null;
  if (!slug) return router.createUrlTree(['/app']);

  const account = await accounts.resolve(slug);
  if (!account) return router.createUrlTree(['/app']);

  // Cuenta existente pero sin membresía: el aislamiento de la base ya lo
  // impediría, pero mostrar una tabla vacía haría parecer que el producto falla.
  if (!accounts.membership()) return router.createUrlTree(['/app']);

  return true;
};
